import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Form} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import {optionsStatus, optionsSubject, roledrp } from '../../Helper'
import moment from 'moment'

import { newsApi } from '../../../utils/AdminDashApi/NewsApi'
import { sessionEntryApi } from '../../../utils/AdminDashApi/SessionEntryApi'
import MobileInputSubComp from './sub_components/MobileInputSubComp'
const SessionEntryCompmb = () => {
    const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
  const [activefrom2,setactivefrom2] = useState("")
  const [activeto2,setactiveTo2] = useState("")
  const [show,setShow] = useState(10)
  const [show2,setShow2] = useState("")

  const [sessionname,setsessionname] = useState("")
  const [startdate,setstartdate] = useState("")
  const [enddate,setenddate] = useState("")
  const [statusmod1,setstatusmod1] = useState("")
  
  const [borderstartdate,setborderstartdate] = useState("")   
  const [borderenddate,setborderenddate] = useState("")
  const [bordersessionname,setbordersessionname] = useState(false)
  const [borderstatusmod1,setborderstatusmod1] = useState("")
  
  const [labelsessionname,setlabelsessionname] = useState("")
  const [labelstartdate,setlabelstartdate] = useState("")    
  const [labelenddate,setlabelenddate] = useState("")
  const [labelstatusmod1,setlabelstatusmod1] = useState("")

  const [sessionname2,setsessionname2] = useState("")
    const [startdate2,setstartdate2] = useState("")
    const [enddate2,setenddate2] = useState("")
    const [statusmod2,setstatusmod2] = useState("")
    
    const [borderstartdate2,setborderstartdate2] = useState("")   
    const [borderenddate2,setborderenddate2] = useState("")
    const [bordersessionname2,setbordersessionname2] = useState(false)
    const [borderstatusmod2,setborderstatusmod2] = useState("")
    
    const [labelsessionname2,setlabelsessionname2] = useState("")
    const [labelstartdate2,setlabelstartdate2] = useState("")    
    const [labelenddate2,setlabelenddate2] = useState("")
    const [labelstatusmod2,setlabelstatusmod2] = useState("")

  
  
 
 
  const handleShow = () => setShow2(true);
 
  const [newArr,setNewArr] = useState([])
  const [classresponse, setclassresponse] = useState([]);
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
}
  useEffect(() => {
    const fetchClassDropdown = async () => {
        try {
            const classresponse = await axios.get(
                "https://sass.britishstandardschool.com/api/Public/ClassList",
                {},
                headers
            );
            setclassresponse(classresponse.data);
            // console.log(classresponse);
        } catch (err) {
            if (err.classresponse) {
                console.error(err.classresponse.data);
                console.log(err.classresponse.status);
                console.log(err.classresponse.header);
            } else {
                console.error(`Error: ${err.message}`);
            }
        }
    };
    fetchClassDropdown();
}, []);
  const optionsShowt = [
    {
      id:0,
      opt:"Select"
    }
    ,{
      id:1,
      opt:10
    },
    {
      id:2,
      opt:20
    },
    {
      id:3,
      opt:30
    },
  ]
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [statusvalueerr,setstatusvalueerr] = useState("")
  const [activefromMoment,setactivefromMoment] = useState("")

  useEffect(()=>{
    var date = moment("2017-07-11")
      var now = moment("2020-07-12");

      if (now > date) {
        console.log("past")
      } else {
        console.log("future")
      }
  },[])
  const [classdrp,setClassdrp] = useState("")
  
  const drpfuncClass=(myval,myid)=>{
    setClassdrp(myid)    
  }
    
  

   

    const [show3, setShow3] = useState(false);

    const handleClose2=()=>{
      setShow3(false)
    }
    const [modalitem,setmodalitem] = useState(null)
    const handleShow3 = (e,myitem) =>{
      setShow3(true)
      setmodalitem(myitem)
      setrolemodalvalue2(myitem.rolename)
      console.log(rolemodalvalue2)
    };
    const handleClosemenumodal= ()=>{
      setShow3(false)
    }
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(sessionEntryApi.data)


  const mainfilter=(searchkey,arr)=>{    
    
    let filteredArr = [];


    if (searchkey) {
        filteredArr = arr.filter((item) => {
          
          const searchMatch = item.subjectname.toLowerCase().includes(searchkey.toLowerCase());
          return searchMatch;
        });
      
      
      } else  {
        filteredArr = arr.filter((item) => {
          return item;
        });
      }

setfilteredArr(filteredArr);
    
  }



  const [tempfilteredarr,settempfilteredarr] = useState([])
    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;        
        setCurrentItems(sessionEntryApi.data.slice(itemOffset, endOffset));        
        setPageCount(Math.ceil(sessionEntryApi.data.length / itemsPerPage));
        
      }, [itemOffset, itemsPerPage]);
      let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
      useEffect(()=>{
        const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
        settempfilteredarr(filteredArr.slice(itemOffsetfiltered, endOffsetfiltered));
        setPageCountfiltered(Math.ceil(pagecountoffilter / itemsPerPagefiltered));
        setpagecountoffilter(filteredArr.length)
      },[itemOffsetfiltered,itemsPerPagefiltered,filteredArr,tempfilteredarr])
    
      // Invoke when user click to request another page.
      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % sessionEntryApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
    
      const handleClose=()=>{
        setShow2(false)
      }
      const [rolemodalvalue,setrolemodalvalue] = useState("")
      const [subjectnamemodalvalue,setsubjectnamemodalvalue] = useState("")
      const [classnamemodalvalue,setclassnamemodalvalue] = useState("")
      
      const [subjectnamemodalvalue2,setsubjectnamemodalvalue2] = useState("")
      const [classnamemodalvalue2,setclassnamemodalvalue2] = useState("")
      const [rolemodalvalue2,setrolemodalvalue2] = useState("")
      const drpfuncclassnamemodal=(mystatus,myid)=>{
        setclassnamemodalvalue(myid)
        
          
      }
      const drpfuncclassnamemodal2=(mystatus,myid)=>{
        setclassnamemodalvalue2(myid)
        
          
      }
      const drpfuncrolemodal=(mystatus,myid)=>{
        setrolemodalvalue(mystatus)
        
          
      }
      const drpfuncsubjectnamemodal=(mystatus,myid)=>{
        setsubjectnamemodalvalue(myid)
        
          
      }
      const drpfuncsubjectnamemodal2=(mystatus,myid)=>{
        setsubjectnamemodalvalue2(myid)
        
          
      }
      const drpfuncrolemodal2=(mystatus,myid)=>{
        setrolemodalvalue2(mystatus)
        console.log("manualselect" , mystatus)
          
      }
      
      const handlesearch =()=>{
    
        setactivefrom("")
      
    }

    

    const [searchinputmodal,setsearchinputmodal] = useState("")
    const [rolesearchkey,setrolesearchkey] = useState("")
    const handlesearchinputmodal=(e)=>{
      setsearchinputmodal(e.target.value)      
    }
    const handlesearchmodal=()=>{
      setrolesearchkey(searchinputmodal)
    }
    const drpfuncshow=(myshow,id)=>{
      setShow(myshow)
      
    }
    
    const [ischkmodal,setischkmodal] = useState(false)
    const handleChangechk = event => {
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
      } else {
        console.log('⛔️ Checkbox is NOT checked');
      }
      setischkmodal(current => !current);
    };
    const handleModaleditsave=()=>{
      console.log(rolemodalvalue2)
      setShow3(false)
    }

   
   

    useEffect(()=>{
      
        mainfilter(mainpagesearch,sessionEntryApi.data)      

      
    },[mainpagesearch])
    
    const handleActiveFrom = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrom(dtfinalc)
        }
        
        
    }
    const [activefromModal1,setactivefromModal1] = useState("")
    const handlestartdateModal1 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setstartdate(dtfinalc)
        }
        
        
    }
    const handlestartdateModal2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setstartdate2(dtfinalc)
        }
        
        
    }
      const handleActiveTo = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTo(dtfinalc)

            
        }
        
        
    }
    const [activeToModal1,setactiveToModal1] = useState("")
      const handleenddateModal1 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setenddate(dtfinalc)

            
        }
        
        
    }
      const handleenddateModal2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setenddate2(dtfinalc)

            
        }
        
        
    }
    const [newsDate1,setnewsDate1] = useState("")
      const handlenewsDateModal1 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setnewsDate1(dtfinalc)

            
        }
        
        
    }
    const [newsDate2,setnewsDate2] = useState("")
      const handlenewsDateModal2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setnewsDate2(dtfinalc)

            
        }
        
        
    }
    // Modal2activefromto 
    
    const handleActiveFrom2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrom2(dtfinalc)
        }
        
        
    }
    const [activefromModal2,setactivefromModal2] = useState("")
    const handleActiveFromModal2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefromModal2(dtfinalc)
        }
        
        
    }
      const handleActiveTo2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTo2(dtfinalc)

            
        }
        
        
    }
    const [activeToModal2,setactiveToModal2] = useState("")
      const handleActiveToModal2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveToModal2(dtfinalc)

            
        }
        
        
    }
    

   
   
    const [subgroupdesMod2,setsubgroupdesMod2] = useState("")
    const handlesubgroupdesMod2=(e)=>{
        setsubgroupdesMod2(e.target.value)
    }
   
    const [newsTitleMod1,setnewsTitleMod1] = useState("")
    const handlenewsTitleMod1=(e)=>{
        setnewsTitleMod1(e.target.value)
    }
    const [newsTitleMod2,setnewsTitleMod2] = useState("")
    const handlenewsTitleMod2=(e)=>{
        setnewsTitleMod2(e.target.value)
    }
    const [descriptionMod1,setdescriptionMod1] = useState("")
    const handledescriptionMod1=(e)=>{
        setdescriptionMod1(e.target.value)
    }
    const [descriptionMod2,setdescriptionMod2] = useState("")
    const handledescriptionMod2=(e)=>{
        setdescriptionMod2(e.target.value)
    }


     
    const [activefromModal1label,setactivefromModal1label] = useState("")
    const [newsDatelabel,setnewsDatelabel] = useState("")
    const [activetoModal1label,setactivetoModal1label] = useState("")
    const [newsTitleMod1label,setnewsTitleMod1label] = useState("")
    const [descriptionMod1label,setdescriptionMod1label] = useState("")
    
    const [descriptionMod2label,setdescriptionMod2label] = useState("")
    const [activefromModal1label2,setactivefromModal1label2] = useState("")
    const [newsDatelabel2,setnewsDatelabel2] = useState("")
    const [activetoModal1label2,setactivetoModal1label2] = useState("")
    const [newsTitleMod2label,setnewsTitleMod2label] = useState("")

    const drpfunctionstatusmod1=(myval,myid)=>{
      setstatusmod1(myval)
    }
    const drpfunctionstatusmod2=(myval,myid)=>{
      setstatusmod2(myval)
    }

    // Validation 

    const handlesaveModal1 = ()=>{
      if(startdate.length==0){
        setlabelstartdate("Start Date Required")
        setborderstartdate("err")
      }else{
        setlabelstartdate("")
        setborderstartdate("")
      }
      if(enddate.length==0){
        setlabelenddate("End Date Required")
        setborderenddate("err")
      }else{
        setlabelenddate("")
        setborderenddate("")
      }
      if(!sessionname && sessionname==""){
        setlabelsessionname("Session name required");
        setbordersessionname(true)
      }
      else{
        setlabelsessionname("")
        setbordersessionname(false)
      }

      if(!statusmod1 && statusmod1==""){
        setlabelstatusmod1("Status Required")
        setborderstatusmod1("err")

      }
      else{
        setlabelstatusmod1("")
        setborderstatusmod1(false)
      }
     
    //   if(newsTitleMod1!=="" &&
    //   newsDate1.length!==0 &&
    //   descriptionMod1!=="" &&
    //   activefromModal1.length!==0 &&      
    //   activeToModal1.length!==0
    //     ){
    //       console.log("Done")
    //       setShow2(false)
    //       setNewArr([...filteredArr,{
    //         newstitle:newsTitleMod1,
    //         newsdate:newsDate1,    
    //         description: descriptionMod1,      
    //         activeFrom:activefromModal1,
    //         activeTo:activeToModal1

    //       }])
    //     }

    }

    const handlesaveModal2 = ()=>{
        if(startdate2.length==0){
            setlabelstartdate2("Start Date Required")
            setborderstartdate2("err")
          }else{
            setlabelstartdate2("")
            setborderstartdate2("")
          }
          if(enddate2.length==0){
            setlabelenddate2("End Date Required")
            setborderenddate2("err")
          }else{
            setlabelenddate2("")
            setborderenddate2("")
          }
          if(!sessionname2 && sessionname2==""){
            setlabelsessionname2("Session name required");
            setbordersessionname2(true)
          }
          else{
            setlabelsessionname("")
            setbordersessionname2(false)
          }
    
          if(!statusmod2 && statusmod2==""){
            setlabelstatusmod2("Status Required")
            setborderstatusmod2("err")
    
          }
          else{
            setlabelstatusmod2("")
            setborderstatusmod2(false)
          }
    }
    const handleClose3=()=>{
      setShow3(false)
    }

    // start
  return (
    <>
    <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>Session Entry</h3>
                </div>
                <div className="admbwrap pb0">
                    <Row>
                        <Col xs={12}>
                        <button className='cmbutton mb-3' onClick={handleShow}> <AiOutlinePlus />Add New Session</button>
                        </Col>
                        <MobileInputSubComp col="6" direct="left" name="Start Date">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                
                                value={activefrom}
                                onChange={(newvaldob)=>handleActiveFrom(newvaldob)}
                                renderInput={(params) => <TextField {...params}inputProps={{
                                    ...params.inputProps,
                                    placeholder: "Start Date"
                                    }} error={false} />}
                            />
                            </LocalizationProvider>
                        </MobileInputSubComp>
                        <MobileInputSubComp col="6" direct="right" name="End Date">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                
                                value={activeto}
                                onChange={(newvaldob)=>handleActiveTo(newvaldob)}
                                renderInput={(params) => <TextField {...params}inputProps={{
                                    ...params.inputProps,
                                    placeholder: "End Date"
                                    }} error={false} />}
                            />
                            </LocalizationProvider>
                        </MobileInputSubComp>
                        <MobileInputSubComp col="12" direct="center" name="Search">
                             <div className="wrap">
                              <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch}/>
                              <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                              </div>
                        </MobileInputSubComp>
                    </Row>
                </div>
                <div className="admbwrap pr0">
                    <div className="tablewrapscroll">
                    <div className="flexvaluetable">
                    <table>
                      <thead>
                        <tr>
                            {
                              sessionEntryApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            filteredArr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={(e)=> handleShow3(e,item)} src={item.action} alt="" />  
                                    </div>  
                                  </td>
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                    </div>
                </div>
                <div className="admbwrap">
                <Row>
                <Col lg={12} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={2}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffset+1} to {itemOffset+10} of {sessionEntryApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
                </div>

                
               {/* modal1ori */}

              <Modal dialogClassName="mymodal" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Session Entry</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                 
                      <Row>
                        
                       <MobileInputSubComp col="6" direct="left" name="Session Name" >
                            <input style={bordersessionname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={sessionname} onChange={(e) => setsessionname(e.target.value)} />
                            <label>{labelsessionname}</label>

                       </MobileInputSubComp>
                                
                      
                      
                        
                    
                    <MobileInputSubComp col="6" direct="right" name="Session Name" >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={startdate}
                                onChange={(newvaldob) => handlestartdateModal1(newvaldob)}
                                renderInput={(params) => <TextField {...params}
                                    style={borderstartdate == "err" ? { border: "1px solid #ED1C24", borderRadius: "10px" } : {}} inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Start Date"
                                    }} error={false} />}
                            />
                            <label>{labelstartdate}</label>
                        </LocalizationProvider>
                    </MobileInputSubComp>

                 <MobileInputSubComp col="6" direct="left" name="End Date" >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={enddate}
                          onChange={(newvaldob)=>handleenddateModal1(newvaldob)}
                          renderInput={(params) => <TextField {...params}  style={borderenddate=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}}  inputProps={{
                              ...params.inputProps,
                              placeholder: "End Date"
                            }} error={false} />}
                      />
                      <label>{labelenddate}</label>                    
                    </LocalizationProvider>
                </MobileInputSubComp>
                  <MobileInputSubComp col="6" direct="right" name="Status" >
                    <div className="dropdownwrapper">
                          <Dropdown2 err={borderstatusmod1} func={drpfunctionstatusmod1} myplaceholder={""} fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsStatus} />
                    </div>
                        <label>{labelstatusmod1}</label>
                     </MobileInputSubComp>

                       
                      </Row>
                   
                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal1}>
                    Save
                  </button>
                </Modal.Footer>

                
              </Modal>

                {/* modal2ori */}
              <Modal dialogClassName="mymodalmenueid" show={show3} onHide={handleClose2} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Session Entry edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>

<Row>
                        
                        <MobileInputSubComp col="6" direct="left" name="Session Name" >
                             <input style={bordersessionname2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={sessionname2} onChange={(e) => setsessionname2(e.target.value)} />
                             <label>{labelsessionname2}</label>
 
                        </MobileInputSubComp>
                                 
                       
                       
                         
                     
                     <MobileInputSubComp col="6" direct="right" name="Session Name" >
                         <LocalizationProvider dateAdapter={AdapterDayjs}>
                             <DatePicker
                                 value={startdate2}
                                 onChange={(newvaldob) => handlestartdateModal2(newvaldob)}
                                 renderInput={(params) => <TextField {...params}
                                     style={borderstartdate2 == "err" ? { border: "1px solid #ED1C24", borderRadius: "10px" } : {}} inputProps={{
                                         ...params.inputProps,
                                         placeholder: "Start Date"
                                     }} error={false} />}
                             />
                             <label>{labelstartdate2}</label>
                         </LocalizationProvider>
                     </MobileInputSubComp>
 
                  <MobileInputSubComp col="6" direct="left" name="End Date" >
                     <LocalizationProvider dateAdapter={AdapterDayjs}>
                       <DatePicker
                           
                           value={enddate2}
                           onChange={(newvaldob)=>handleenddateModal2(newvaldob)}
                           renderInput={(params) => <TextField {...params}  style={borderenddate2=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}}  inputProps={{
                               ...params.inputProps,
                               placeholder: "End Date"
                             }} error={false} />}
                       />
                       <label>{labelenddate2}</label>                    
                     </LocalizationProvider>
                 </MobileInputSubComp>
                   <MobileInputSubComp col="6" direct="right" name="Status" >
                   <div className="dropdownwrapper">
                    <Dropdown2 err={borderstatusmod2} func={drpfunctionstatusmod2} myplaceholder={""} fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsStatus} />
                </div>
                    <label>{labelstatusmod2}</label>
                      </MobileInputSubComp>
 
                        
                       </Row>  

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal2}>
                    Save
                  </button>
                </Modal.Footer>
              </Modal>
            </div>
        </div>
    </div>
    </>
  )
}

export default SessionEntryCompmb